enum WindowMessages {
  WRITE_QNA = 'WRITE_QNA',
  LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED',
  FILTER_MY_QNA = 'FILTER_MY_QNA',
  BUY = 'BUY',
  CART = 'CART',
  PHONE_AUTHENTICATED = 'PHONE_AUTHENTICATAED',
  IPIN_AUTHENTICATED = 'IPIN_AUTHENTICATAED',
  ADD_TALKTALK = 'ADD_TALKTALK',
  PRODUCT_ZZIM = 'PRODUCT_ZZIM',
  STORE_ZZIM = 'STORE_ZZIM',
  INTEREST_TALKTALK = 'INTEREST_TALKTALK',
  INTEREST_STORE_ZZIM = 'INTEREST_STORE_ZZIM',
  REPORT = 'REPORT',
  REVIEW_MODIFIED = 'REVIEW_MODIFIED',
  REVIEW_REGISTERED = 'REVIEW_REGISTERED',
}

namespace WindowMessages {
  const windowMessages = {
    WRITE_QNA: { isLoggedIn: true, description: 'QNA 작성(팝업) 완료' },
    LOGIN_SUCCEEDED: { isLoggedIn: true, description: '로그인(팝업) 성공(LoginRedirect 처리의 default 메시지)' },
    FILTER_MY_QNA: { isLoggedIn: true, description: '나의 QnA 조회 - 로그인(팝업) 성공' },
    BUY: { isLoggedIn: true, description: 'PC 상세 구매 버튼 - 로그인(팝업) 성공' },
    CART: { isLoggedIn: true, description: 'PC 상세 장바구니 - 로그인(팝업) 성공' },
    PHONE_AUTHENTICATED: { isLoggedIn: false, description: 'PHONE_AUTHENTICATED' },
    IPIN_AUTHENTICATED: { isLoggedIn: false, description: 'IPIN_AUTHENTICATED' },
    ADD_TALKTALK: { isLoggedIn: true, description: '톡톡친구 추가 - 로그인(팝업) 성공' },
    PRODUCT_ZZIM: { isLoggedIn: true, description: '상품찜 추가 - 로그인(팝업) 성공' },
    INTEREST_TALKTALK: { isLoggedIn: true, description: '관심맺기 톡톡친구 레이어 - 로그인(팝업) 성공' },
    INTEREST_STORE_ZZIM: { isLoggedIn: true, description: '관심맺기 스토어찜 레이어 - 로그인(팝업) 성공' },
    STORE_ZZIM: { isLoggedIn: true, description: '스토어찜 추가 - 로그인(팝업) 성공' },
    REPORT: { isLoggedIn: true, description: 'QNA/구매평 - 로그인(팝업) 성공' },
    REVIEW_MODIFIED: { isLoggedIn: true, description: '리뷰 수정 성공' },
    REVIEW_REGISTERED: { isLoggedIn: true, description: '리뷰 등록 성공' },
  }

  export const isLoggedIn = (message: WindowMessages): boolean => {
    return windowMessages[message] ? windowMessages[message].isLoggedIn : false
  }
}

export default WindowMessages
